import _get from 'lodash-es/get';
import { connect } from 'react-redux';

import SelectPlan from './SelectPlan';
import {
  getAllProgramsInitiate,
  getProgramInfoInitiate,
} from '../../../../../../actions/programs';
import { openErrorToast } from '../../../../../../reducers/uiLogic';
import { currentFlowTypeEnum } from '../../../../../common/components/constants';
import { getAllQuestionsInitiate } from '../../../../../../actions/questions';

const mapStateToProps = state => {
  const programsData = _get(state, 'programs', {});
  const programInfo = _get(state, 'programs.programInfo', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    programsData,
    selectedWorkspace,
    fetchingWorkspaces:
      _get(state, 'apiState.GET_ALL_WORKSPACES.isFetching', true) &&
      !_get(state, 'apiState.GET_ALL_WORKSPACES.isIdle', false),
    fetchedWorkspaces: _get(state, 'apiState.GET_ALL_WORKSPACES.success', true),
    fetchingPrograms:
      _get(state, 'apiState.GET_PROGRAMS.isFetching', true) &&
      !_get(state, 'apiState.GET_PROGRAMS.isIdle', false),
    fetchedPrograms: _get(state, 'apiState.GET_PROGRAMS.success', true),
    programInfo,
    fetchingProgramInfo:
      _get(state, 'apiState.GET_PROGRAM_INFO.isFetching', true) &&
      !_get(state, 'apiState.GET_PROGRAM_INFO.isIdle', false),
    fetchedProgramInfo: _get(state, 'apiState.GET_PROGRAM_INFO.success', true),
  };
};

const mapDispatchToProps = dispatch => ({
  getProgramInfo: payload => dispatch(getProgramInfoInitiate(payload)),
  getAllPrograms: payload => dispatch(getAllProgramsInitiate(payload)),
  // getSelectedWorkspace: payload => dispatch(getAllWorkspacesInitiate(payload)),
  showErrorToast: message => dispatch(openErrorToast(message)),
  getAllQuestions: payload => dispatch(getAllQuestionsInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectPlan);
